import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://ceremind-backend.onrender.com";
export const COLLABORATOR_TOKEN_STORAGE_KEY = "collaborator_token";
export const COLLABORATOR_LEGACY_STORAGE_PREFIX = "collab_account_";
export const COLLABORATOR_LEGACY_SESSION_KEY = "collab_session";

export const collaboratorApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

export function getCollaboratorToken() {
  return window.localStorage.getItem(COLLABORATOR_TOKEN_STORAGE_KEY);
}

export function setCollaboratorToken(token) {
  window.localStorage.setItem(COLLABORATOR_TOKEN_STORAGE_KEY, token);
}

export function clearCollaboratorToken() {
  window.localStorage.removeItem(COLLABORATOR_TOKEN_STORAGE_KEY);
}

collaboratorApi.interceptors.request.use((config) => {
  const token = getCollaboratorToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

collaboratorApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearCollaboratorToken();
    }
    return Promise.reject(error);
  },
);

export default collaboratorApi;
